/* 
  this is the base class for each pump (acid, base, feed, antifoam)
  it implements all the required features 
  in its descendant classes you only specify its type (acid, base, feed, antifoam)
*/

import template	from "./dialog-config-pump.html";
import css		from "./dialog-config-pump.css";

import Dialog	from "dialog";
import {Label}  from "gui";
import sleep	from "sleep";


class ConfigPumpDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-pump", ConfigPumpDialog);
  }
  constructor(...args) {
    super(...args);

    this.show();
  }
  connectedCallback() {
    super.connectedCallback();

    this.onupdatedevices_handler_f = this.onupdatedevices_handler.bind(this);
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler_f);

    this.onupdatedevices_handler({detail: application.devices});

    this.spinnerTargetRPM.value = this.textboxCurrentRPM.value;
    this.spinnerTargetMLH.value = this.textboxCurrentMLH.value;        
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener("onupdatedevices", this.onupdatedevices_handler_f);
  }
  buttonClose_click(event) {
    this.close();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices[`${this.__type}Pump`].id;
    this.textboxDeviceStatus.value = devices[`${this.__type}Pump`].status;
    this.textboxCurrentRPM.value = devices[`${this.__type}Pump`].rpm;
    this.textboxCurrentMLH.value = devices[`${this.__type}Pump`].mlh;
    this.textboxCalibrationStatus.value = devices[`${this.__type}Pump`].calibrationStatus;
    this.spinnerSumML.value = Math.round(parseFloat(devices[`${this.__type}Pump`].sumML)*10)/10;
  }
  spinnerTargetRPM_change(event) {
    server.rcall(`RM_${this.__type}pump_setRPM`, this.spinnerTargetRPM.value).catch(function(result) {
      alert(result);
    });
  }
  spinnerTargetMLH_change(event) {
    server.rcall(`RM_${this.__type}pump_setMLH`, this.spinnerTargetMLH.value).catch(function(result) {
      alert(result);
    });
  }
  async buttonCalibrate_click(event) {
    try {
      this.iconCalibrate.style.display = "block";
      this.iconCalibrate.style.animationName = "spin";
      this.iconCalibrate.iconname = "view-refresh";
      await server.rcall(`RM_${this.__type}pump_calibrate`, this.spinnerCalibrationRPM.value, this.spinnerCalibrationMLH.value);
      this.iconCalibrate.iconname = "dialog-ok-apply";    
    } catch(e) {
      this.iconCalibrate.iconname = "process-stop";    
    } finally {
      this.iconCalibrate.style.animationName = "";
      await sleep(2000);
      this.iconCalibrate.style.display = "none";
    }
  }
  async buttonClearSum_click(event) {
    try {
      this.iconClearSum.style.display = "block";      
      this.iconClearSum.style.animationName = "spin";
      this.iconClearSum.iconname = "view-refresh";
      await server.rcall(`RM_${this.__type}pump_clearsum`);
      this.iconClearSum.iconname = "dialog-ok-apply";    
    } catch(e) {
      this.iconClearSum.iconname = "process-stop";    
    } finally {
      this.iconClearSum.style.animationName = "";
      await sleep(2000);
      this.iconClearSum.style.display = "none";
    }
  }    
  set type(value) {
    this.__type = value;
    this.appendChild( new Label({
      slot: "header",
      value: `Config - Pump ${value}`
    }) );
  }
  get type() {
    return this.__type;
  }
}

ConfigPumpDialog.constructor();

export default ConfigPumpDialog;